import { AUTH_USER, GENERIC_MESSAGE, NEW_MESSAGE } from '../constants/actions';
import { showNotification, initializeNotifications } from './notification-utils';

const handleAuthUser = () => {
  initializeNotifications();
};

const handleGenericMessage = ({ payload }) => {
  const { name, body } = payload || {};
  if (!name || !body) {
    console.debug('Skipping notification: Missing name or body in action payload');
    return;
  }
  showNotification({
    title: name,
    body,
  });
};

const handleNewMessage = (store, { payload }) => {
  const state = store.getState();
  const currentUserId = state?.auth?.user?._id;
  const message = payload?.message;

  if (!message) {
    console.debug('Skipping notification: message is empty');
    return;
  }

  const {
    author, isAI, messageBody, id,
  } = message;

  if (isAI || !author || author?.id === currentUserId) {
    console.debug('Skipping notification: message is from AI or author is current user');
    return;
  }
  const participants = message.participants || [];
  if (participants.includes(currentUserId)) {
    showNotification({
      title: author?.name || 'new message',
      body: messageBody,
      tag: id,
    });
  }
};

const notificationsMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case AUTH_USER:
      handleAuthUser();
      break;
    case GENERIC_MESSAGE:
      handleGenericMessage(action);
      break;
    case NEW_MESSAGE:
      handleNewMessage(store, action);
      break;
    default:
      break;
  }
  return next(action);
};

export default notificationsMiddleware;
